import { ManifestConfig } from './config';
import { PluginLogger } from './types';
import { verifyConnection } from './verify';

/* eslint-disable @typescript-eslint/no-explicit-any */
export function registerCommand(api: any, config: ManifestConfig, logger: PluginLogger): void {
  if (typeof api.registerCommand !== 'function') {
    logger.debug('[manifest] registerCommand not available, skipping /manifest command');
    return;
  }

  const formatStatus = async (): Promise<string> => {
    try {
      const check = await verifyConnection(config);
      const lines = [
        `Dev mode: ${config.devMode ? 'yes' : 'no'}`,
        `Endpoint reachable: ${check.endpointReachable ? 'yes' : 'no'}`,
        `Auth valid: ${check.authValid ? 'yes' : 'no'}`,
      ];
      if (check.agentName) {
        lines.push(`Agent: ${check.agentName}`);
      }
      if (check.error) {
        lines.push(`Error: ${check.error}`);
      }
      return lines.join('\n');
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : String(err);
      return `Manifest status check failed: ${msg}`;
    }
  };

  api.registerCommand({
    name: 'manifest',
    description: 'Show Manifest plugin status and connection info',
    async handler() {
      return formatStatus();
    },
    async execute() {
      const text = await formatStatus();
      return { text, content: [{ type: 'text', text }] };
    },
  });

  logger.debug('[manifest] Registered /manifest command');
}
